<template>
    <b-modal id="create-edit-announcements-modal" :title="mode === 'create' ? 'ارسال پیام جدید' : 'ویرایش پیام'"
        :ok-disabled="disabled || disabledBtn" :cancel-disabled="disabled || disabledBtn" @ok.prevent="submit"
        class="in-form-modal" ok-title="ثبت" cancel-title="لغو" size="lg">
        <form ref="form" @submit.prevent="submit">
            <b-form-group class="col-md-12" v-if="mode == 'create'">
                <CustomerSearch v-model="announcement.selectedCustomer" :allow-empty="true" :show-label="false" />
            </b-form-group>
            <b-form-group class="col-md-12">
                <label for="title">عنوان پیام</label>
                <b-form-input v-model="announcement.title" id="title"></b-form-input>
            </b-form-group>
            <b-form-group class="col-md-12">
                <label for="description">متن پیام</label>
                <b-form-textarea id="description" v-model="announcement.description"></b-form-textarea>
            </b-form-group>
        </form>
    </b-modal>
</template>
<script>
import CreateEditAnnouncementsModalLmpl from '@@/core/pages/Announcements/CreateEditAnnouncementsModal/CreateEditAnnouncementsModalLmpl'
import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";

export default {
    components: { CustomerSearch },
    extends: CreateEditAnnouncementsModalLmpl
}
</script>